import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/oilcard",
  component: function component() {
    return import("../../../views/oil-card/oilcard.vue");
  },
  name: "oilcard",
  meta: {
    title: "IC卡",
    foot: true
  }
}, {
  path: "/oilcard_index/:id?",
  component: function component() {
    return import("../../../views/oil-card/oilcard_index.vue");
  },
  name: "oilcard_index",
  meta: {
    title: "IC卡",
    foot: true
  }
}, {
  path: "/oil_bind_card",
  component: function component() {
    return import("../../../views/oil-card/oil_bind_card.vue");
  },
  name: "oil_bind_card",
  meta: {
    title: "IC卡",
    foot: true
  }
}];